/**
 * Der Zugang zum Server.
 *
 * Anders als in der Fahrer-App wird die Sitzung hier vom Supabase-Client
 * selbst gehalten. Grund: In der App schützt eine PIN das Gerät, das im
 * Führerhaus liegt und mitfahren kann. Ein Büro-Rechner steht im Büro; dort
 * ist die übliche Anmeldung mit E-Mail und Passwort das richtige Maß, und
 * eine Seite, die nach jedem Neuladen erneut nach dem Passwort fragt, wird
 * im Alltag umgangen (Zettel am Monitor). Deshalb: persistSession an.
 *
 * Der Schlüssel unten darf öffentlich sein. Er erlaubt für sich genommen
 * nichts — jeden einzelnen Zugriff regelt die Zeilensicherheit in der
 * Datenbank anhand der angemeldeten Person. Wer hier ohne Konto anklopft,
 * bekommt leere Listen zurück, keine Daten.
 */

import { createClient } from '@supabase/supabase-js';

export const SUPABASE_URL = 'https://fqjelaafrrnpwsfbuowj.supabase.co';

export const SUPABASE_PUBLISHABLE_KEY =
  'sb_publishable_V5NAqciY12kR6BLeIJm3rQ_1zRmCxW-';

export const supabase = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    // Wir arbeiten nicht mit Anmeldelinks in der Adresszeile. Diese Prüfung
    // abzuschalten spart einen Fall, in dem eine kaputte URL die Anmeldung
    // durcheinanderbringt.
    detectSessionInUrl: false,
    storageKey: 'haid-jerg-backoffice',
  },
});
